import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const RECEIVE_PARTNER = 'RECEIVE_PARTNER'
export const REFER_PARTNER = 'REFER_PARTNER'
export const REQUEST_PARTNER = 'REQUEST_PARTNER'
export const SAVE_PARTNER = 'SAVE_PARTNER'
export const UPDATE_AND_SAVE_PARTNER = 'UPDATE_AND_SAVE_PARTNER'

export const requestPartner = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_PARTNER })

    const { profile } = getState()

    const { id: userId } = profile

    axios
        .get(`/partner/${userId}`)
        .then((response) => {
            const data = _get(response, ['data'], {})
            dispatch(receivePartner({ ...data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(receivePartner({ fetchSuccessful: true }))
                return
            }

            dispatch(receivePartner({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receivePartner = (data) => ({ type: RECEIVE_PARTNER, data })

export const referPartner =
    ({ hideAlert } = {}) =>
    (dispatch, getState) => {
        dispatch({ type: REFER_PARTNER })
        const { profile } = getState()
        const { id: userId } = profile

        return axios
            .post(`/partner/${userId}/refer`)
            .then((response) => {
                dispatch(receivePartner(response.data))
                if (!hideAlert) {
                    dispatch(receiveSuccessAlert('Invite sent'))
                }
            })
            .catch((error) => {
                if (!hideAlert) {
                    dispatch(handleRequestError(error))
                }
                return Promise.reject(error)
            })
    }

export const updateAndSavePartner = (data, options) => (dispatch) => {
    dispatch({ type: UPDATE_AND_SAVE_PARTNER, data })

    dispatch(receivePartner(data))
    return dispatch(savePartner(options))
}

export const savePartner =
    ({ hideAlert } = {}) =>
    (dispatch, getState) => {
        dispatch({ type: SAVE_PARTNER })

        const { profile, partner } = getState()

        const { id: userId } = profile

        return axios
            .put(`/partner/${userId}`, { ...partner, userId })
            .then((response) => {
                dispatch(receivePartner(response.data))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert('Partner details updated'))
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }
